'use client';

import { useCallback, useState } from 'react';

import { useUpdateEffect } from './useUpdateEffect';

export function useLocalStorage<Value>(key: string, initialValue: Value) {
  const getInitialValue = useCallback(() => {
    if (typeof window === 'undefined') {
      return initialValue;
    }

    const storedValue = window.localStorage.getItem(key);

    if (storedValue) {
      try {
        return JSON.parse(storedValue) as Value;
      } catch {
        return initialValue;
      }
    }

    return initialValue;
  }, [initialValue, key]);

  const [value, setValue] = useState(getInitialValue);

  useUpdateEffect(() => {
    setValue(getInitialValue());
  }, [getInitialValue]);

  useUpdateEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value, key]);

  return { setValue, value };
}
